import styled from 'styled-components';

export default styled.select`
  width: 100%;
  border: none;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border: 1px solid ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.gray[900]};
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  height: 34px;
  border-radius: 4px;
  outline: none;
  padding: 0 12px;
  font-size: 14px;
  transition: border-color 0.2s ease-in;

  &:focus {
  border-color: ${({ theme }) => theme.colors.primary.main};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.gray[201]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: ${({ theme }) => theme.colors.background} !important;
  }
`;
